import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { storeOwnerQueries } from '@/services/storeOwner/storeOwner.queries';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

const useUpdateStoreInfo = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('updateBasicStoreInfo', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: storeOwnerQueries.all() });
      toast.success(res.message);
      void navigate({ to: '/store-information/basic-stores' });
      await revalidate(['clubBasicInfo', 'availableTime', 'clubSchedule']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { mutateAsync };
};

export default useUpdateStoreInfo;
